import { __decorate, __metadata } from "tslib";
import { Directive, ElementRef, HostListener, Output, EventEmitter, Input } from '@angular/core';
let ClickOutsideDirective = class ClickOutsideDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new EventEmitter();
    }
    onMouseEnter(targetElement) {
        var _a;
        const clickedInside = (_a = (this.clickOutsideElement
            ? this.clickOutsideElement
            : this._elementRef.nativeElement)) === null || _a === void 0 ? void 0 : _a.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
};
ClickOutsideDirective.ctorParameters = () => [
    { type: ElementRef }
];
ClickOutsideDirective.propDecorators = {
    clickOutsideElement: [{ type: Input }],
    clickOutside: [{ type: Output, args: ['clickOutside',] }],
    onMouseEnter: [{ type: HostListener, args: ['document:click', ['$event.target'],] }]
};
ClickOutsideDirective = __decorate([
    Directive({
        selector: '[clickOutside]',
    }),
    __metadata("design:paramtypes", [ElementRef])
], ClickOutsideDirective);
export { ClickOutsideDirective };
